import React, { Component } from "react";
import "./Home.css";
import TermsAndConditions from "../components/TermsAndConditions";

export default class Terms extends Component {
  render() {
    return (
        <div className="Home">
        <TermsAndConditions/> 
        </div>     
   );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Terms.js